<template>
  <b-modal 
    id="modal-1"
    ref="modal"
    :title="item.title"
    @show="showModal"
    @ok="hideModal"
    ok-title="Закрыть"
    cancel-title=""
    cancel-variant="light"
    footer-class="justify-content-between"
  >
    <p class="text-center"><img class="img-fluid" :src="item.picture" alt=""></p>
    <p class="semibold mb-0 text-grey fz-sm">Дата и время: {{ item.date }}</p>
    <p class="semibold">{{ item. title }}</p>
    <p class="semibold">{{ item. description }}</p>
  </b-modal>
</template>

<script>
export default {
  props: {
    item: [Object]
  },
  data () {
    return {
    }
  },
  methods: {
    showModal () {
      this.$refs['modal'].show()
    },
    hideModal () {
      this.$refs['modal'].hide()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
  }
}
</script>